import api from "../config/api";

export const getCartByCustomerId = async (customerId)=>{
  const res = await api.get(`/cart/?customerId=${customerId}`)
  return res.data;
}

export const getCartProductsByCustomerId = async (customerId)=>{
  const res = await api.get(`/cart/?custId=${customerId}`)
  return res.data;
}

export const createCart = async (data) => {
  const res = await api.post(`/cart/`, data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data.data;
}

export const updateCart= async(id, cartData)=>{
    const res = await api.post(`/cart/?id=${id}`,cartData);
    console.log('res : ',res);
    
    return res.data;
}

export const deleteCart = async (id) => {
  const res = await api.delete(`/cart/?id=${id}`);
  return res.data.data;
} 